import { ComponentPropsWithoutRef, forwardRef, ReactNode, Ref } from 'react';
import styled from 'styled-components';

const StyledVisuallyHidden = styled.span`
	border: 0;
	clip: rect(1px, 1px, 1px, 1px);
	clip-path: inset(50%);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
	word-wrap: normal !important;
`;

interface VisuallyHiddenProps extends Omit<ComponentPropsWithoutRef<'span'>, 'children'> {
	/**
	 * The content to be visually hidden.
	 */
	children: ReactNode;
}

function CellulaVisuallyHidden({ children, ...rest }: VisuallyHiddenProps, ref: Ref<HTMLSpanElement>): JSX.Element {
	return (
		<StyledVisuallyHidden {...rest} ref={ref}>
			{children}
		</StyledVisuallyHidden>
	);
}

/* ########################################################################## */
/* ############################### PUBLIC API ############################### */
/* ########################################################################## */

/**
 * A component to insert visually hidden content. Primarily used to add extra
 * content for Assistive technology such as Screen readers to help the user
 * understand the context.
 */
const VisuallyHidden = forwardRef(CellulaVisuallyHidden);

export type { VisuallyHiddenProps };
export { VisuallyHidden };
